import React, {useState, useEffect} from 'react';
import {Card, Page, Layout, List, Button, Icon} from '@shopify/polaris';
import createApp from '@shopify/app-bridge';
import {Redirect} from '@shopify/app-bridge/actions';
import {getSessionToken} from "@shopify/app-bridge-utils";

function Subscription() {
    const [subscription, setSubscription] = useState(null);
    const [config, setConfig] = useState(null);

    useEffect(() => {
        fetchSubscription();
    }, []);

    const fetchSubscription = async () => {
        let configApp = {
            apiKey: window['apiKey'],
            host: window['host']
        };
        setConfig(configApp);
        window['bridge-app'] = createApp(configApp);

        const sessionToken = await getSessionToken(window['bridge-app']);
        if (sessionToken) {
            const settings = {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + sessionToken
                }
            };
            const response = await fetch('https://hide-price.webpanda-solutions.com/api/subscription/current/' + window.$queryString, settings);
            // if user session expired reload the page
            if (response.status === 403) {
                window.location.reload();
                return false;
            }

            const responseJson = await response.json();

            if (response.status === 274) {
                window.location.href = 'https://hide-price.webpanda-solutions.com/login/' + window.$queryString;
                return false;
            }
            if (response.status === 275) {
                const redirect = Redirect.create(window['bridge-app']);
                redirect.dispatch(Redirect.Action.REMOTE, responseJson.redirect_url);
                return false;
            }
            setSubscription(responseJson);

            let card;
            switch(responseJson.subscription) {
                case 1:
                    card = document.querySelector('.Polaris-Layout__Section:first-child .Polaris-Card')
                    break;
                case 2:
                    card = document.querySelector('.Polaris-Layout__Section:nth-child(2) .Polaris-Card');
                    break;
                case 3:
                    card = document.querySelector('.Polaris-Layout__Section:nth-child(3) .Polaris-Card');
                    break;
                default:
                    // nothing
            }
            card.style.border = '2px solid #2FA822';
        }
    };

    const upgradeSubscription = async () => {
        getSessionToken(window['bridge-app'])
            .then((sessionToken) => {
                const settings = {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + sessionToken
                    }
                };
                fetch(`https://hide-price.webpanda-solutions.com/api/subscription/upgrade/${window.$queryString}`, settings)
                    .then(response => {
                        // if user session expired reload the page
                        if (response.status === 403) {
                            window.location.reload();
                            return false;
                        }

                        return response.json();
                    }).then(response => {
                        const redirectUrl = response;
                        if (redirectUrl) {
                            const redirect = Redirect.create(window['bridge-app']);
                            redirect.dispatch(Redirect.Action.REMOTE, redirectUrl);
                        }
                    });
            })
            .catch((err) => console.log(err));
    };

    const upgradeYearlySubscription = async () => {
        getSessionToken(window['bridge-app'])
            .then((sessionToken) => {
                const settings = {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + sessionToken
                    }
                };
                fetch(`https://hide-price.webpanda-solutions.com/api/subscription/upgradeyearly/${window.$queryString}`, settings)
                    .then(response => {
                        // if user session expired reload the page
                        if (response.status === 403) {
                            window.location.reload();
                            return false;
                        }

                        return response.json();
                    }).then(response => {
                        const redirectUrl = response;
                        if (redirectUrl) {
                            const redirect = Redirect.create(window['bridge-app']);
                            redirect.dispatch(Redirect.Action.REMOTE, redirectUrl);
                        }
                    });
            })
            .catch((err) => console.log(err));
    };

    const downgradeSubscription = async () => {
        getSessionToken(window['bridge-app'])
            .then((sessionToken) => {
                const settings = {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + sessionToken
                    }
                };
                fetch(`https://hide-price.webpanda-solutions.com/api/subscription/downgrade/${window.$queryString}`, settings)
                    .then(response => {
                        // if user session expired reload the page
                        if (response.status === 403) {
                            window.location.reload();
                            return false;
                        }

                        return response.json();
                    }).then(response => {
                        const redirectUrl = response;
                        if (redirectUrl) {
                            const redirect = Redirect.create(window['bridge-app']);
                            redirect.dispatch(Redirect.Action.REMOTE, redirectUrl);
                        }
                    });
            })
            .catch((err) => console.log(err));
    };

    return (
        <Page
            title="Manage Subscription Plan"
            breadcrumbs={[{content: 'Dashboard', url: `/${window.$queryString}`}]}
        >
            <Layout>
                <Layout.Section oneThird>
                    <Card title="Basic Plan" sectioned>
                        <div style={{fontWeight: 'bold', fontSize: '1.6rem'}}>
                            $6 per month
                        </div>
                        <br/>
                        <List type="bullet">
                            <List.Item>Hide price for not logged customers</List.Item>
                            <List.Item>Easily enable/disable the functionality</List.Item>
                            <List.Item>Everything about the message box is customizable</List.Item>
                        </List>
                        {
                            subscription && subscription.subscription >= 2 ?
                                [
                                    <br/>,
                                    <Button onClick={downgradeSubscription} primary>Downgrade</Button>
                                ]
                                :
                                ''
                        }
                    </Card>
                </Layout.Section>
                <Layout.Section oneThird>
                    <Card title="Premium Plan" sectioned>
                        <div style={{fontWeight: 'bold', fontSize: '1.6rem'}}>
                            $10 per month
                        </div>
                        <br/>
                        <List type="bullet">
                            <List.Item>All features from the Basic Plan</List.Item>
                            <List.Item>Select the Products for which to hide the price</List.Item>
                            <List.Item>Translate message box for each language you have on your store</List.Item>
                            <List.Item>Hide prices based on customer tags</List.Item>
                        </List>
                        {
                            subscription && subscription.subscription !== 2 ?
                                [
                                    <br/>,
                                    <Button onClick={upgradeSubscription} primary>Upgrade</Button>
                                ]
                                :
                                ''
                        }
                    </Card>
                </Layout.Section>
                <Layout.Section oneThird>
                    <Card title="Yearly Plan" sectioned>
                        <div style={{fontWeight: 'bold', fontSize: '1.6rem'}}>
                            $80 per year
                        </div>
                        <br/>
                        <List type="bullet">
                            <List.Item>All features from the Premium Plan</List.Item>
                        </List>
                        {
                            subscription && subscription.subscription < 3 ?
                                [
                                    <br/>,
                                    <Button onClick={upgradeYearlySubscription} primary>Upgrade</Button>
                                ]
                                :
                                ''
                        }
                    </Card>
                </Layout.Section>
            </Layout>
        </Page>
    );
}

export default Subscription;
